import React, { useContext, useState, useRef, useEffect } from 'react';
import './Navbar.css';
import logo from '../Assets/picture53.png';  
import dropdown from '../Assets/dropdown.png';  
import cart from '../Assets/cart.png'; 
import { Link } from 'react-router-dom';
import { ShopContext } from '../../Context/ShopContext';


const Navbar = () => {
  const [menu, setMenu] = useState("shop");
  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const { cartCount, getTotalCartItems } = useContext(ShopContext);
  const menuRef = useRef();
 

  //Navbarcount
  const { cartItems } = useContext(ShopContext);

  
  const totalItems =
    cartItems &&
    Object.values(cartItems).reduce((acc, quantity) => acc + quantity, 0);


  // Function to toggle dropdown menu
  const dropdown_toggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isMenuOpen]);

  return (
    <div className="navbar">
      <div className="nav-logo">
        <img src={logo} alt="logo" style={{  maxWidth: "clamp(110px, 22vw, 150px)",   
    width: "100%",      
    height: "auto",
    display: "block"  }} />
      </div>

      {/* Dropdown Icon */}
      <img className="nav-dropdown" onClick={dropdown_toggle} src={dropdown} alt="dropdown" />

      {/* Menu Items */}
      <ul ref={menuRef} className={`nav-menu ${isMenuOpen ? "nav-menu-visible" : ""}`}>
        <li onClick={() => setMenu("shop")}><Link to='/'>Shop</Link>{menu === "shop" && <hr/>}</li>
        <li onClick={() => setMenu("about")}><Link to='/about'>About Us</Link>{menu === "about" && <hr/>}</li>
        <li onClick={() => setMenu("blog")}><Link to='/blog'>Blog</Link>{menu === "blog" && <hr/>}</li>
        <li onClick={() => setMenu("spices")}><Link to='/spices'>Spices</Link>{menu === "spices" && <hr/>}</li>
        <li onClick={() => setMenu("snacks")}><Link to='/snacks'>Snacks</Link>{menu === "snacks" && <hr/>}</li>
        <li onClick={() => setMenu("drinks")}><Link to='/drinks'>Drinks</Link>{menu === "drinks" && <hr/>}</li>
        <li onClick={() => setMenu("condiment_jam")}><Link to='/condiment_jam'>Condiment & Jam</Link>{menu === "condiment_jam" && <hr/>}</li>
      </ul>

      {/* Login and Cart Section */}
      <div className="nav-login-cart">
      {localStorage.getItem('auth-token')
      ?<button onClick={()=>{localStorage.removeItem('auth-token');window.location.replace("/");}}>Logout</button>:
        <Link to='/login'><button>Login</button></Link>}
       
       
        <Link to='/cart'> 
          <img src={cart} alt="cart" style={{ width: '50px', height: 'auto' }} />
        </Link>
        <div className="nav-cart-count">{getTotalCartItems()}</div> 
      </div>
    </div>
  );
};

 export default Navbar;
